export default {
  data: () => ({
    Airport: {
      key: 'AIRPORT',
      value: 'Lotnisko'
    },
    RailwayStation: {
      key: 'RAILWAY_STATION',
      value: 'Dworzec kolejowy'
    },
    Other: {
      key: 'OTHER',
      value: 'Pozostałe'
    }
  }),
  methods: {
    getLocationTypes() {
      return [this.Airport, this.RailwayStation, this.Other]
    },
    getLocationTypeLabel(value) {
      return this.getLocationTypes().find((tc) => tc.key === value).value
    },
  }
}
